module.exports = __webpack_public_path__ + "static/media/0320_Small.9d89519b.jpg";